export const LEVELS = [
    'Unspecifieid',
    'Basic',
    'Conversational',
    'Fluent',
    'Native/Bilingual'
];



// WEBPACK FOOTER //
// ./src/common/InfoPanel/SellerProfile/Languages/const.js